"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpaleAbilityHandler = exports.ImpaleActorAbilityFactory = exports.ImpaleAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
class ImpaleAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Impale;
        this.__typeName = "Impale";
    }
}
exports.ImpaleAbilityArgs = ImpaleAbilityArgs;
let ImpaleActorAbilityFactory = class ImpaleActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Impale", "OneEnemies", 2);
    }
};
ImpaleActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Impale")
], ImpaleActorAbilityFactory);
exports.ImpaleActorAbilityFactory = ImpaleActorAbilityFactory;
let ImpaleAbilityHandler = class ImpaleAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            projectileType: "SpinningAxe",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 70)
            ],
            onHit: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.BleedingEffectArgs("Power", 10),
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, Math.round(level * .5))
                    ], true)
                });
            }
        });
    }
};
ImpaleAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Impale)
], ImpaleAbilityHandler);
exports.ImpaleAbilityHandler = ImpaleAbilityHandler;
